module.exports = __webpack_public_path__ + "img/6.399877a7.jpg";